module.exports = __webpack_public_path__ + "img/overview-left-arrow.5df67d4.svg";